import store from '@/store/store'

export default {
  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  path: '',
    component: () => import('@/layouts/full-page/FullPage.vue'),
  children: [
  // {
  //   path:'/offline',
  //   name: 'offline',
  //   component: () => import('@/views/Offline.vue')
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/pages/Register.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('@/views/pages/VerifyEmail.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/identify-user',
    name: 'identify-user',
    component: () => import('@/views/pages/IdentifyUser.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/email-sent',
    name: 'email-sent',
    component: () => import('@/views/pages/EmailSent.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/pages/ResetPassword.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/thank-you',
    name: 'thank-you',
    component: () => import('@/views/pages/ThankYou.vue'),
    beforeEnter(to, from, next)  {
      store.dispatch('auth/validate').then(result => {
        result ? next('/') : next()
      })
    }
  },
  {
    path: '/not-found-404',
    name: 'notFound404',
    component: () => import('@/views/pages/Error404.vue'),
  },
]
}
